import EnvItem from './env-item.vue'
EnvItem.install = function (Vue) {
  Vue.component(EnvItem.name, EnvItem);
};
export default EnvItem



// WEBPACK FOOTER //
// ./src/omnis-business/env-item/index.js